const state = {
    data: []
}

const mutations = {
    storeUsers (state, payload) {
        state.data = payload
    },
    storeUser (state, payload) {
        state.data.unshift(payload)
    },
    updateUser (state, payload) {
        let user = state.data.find(item => item.id === payload.id)

        user = payload
    },
    changeStatusUser (state, payload) {
        const user = state.data.find(item => item.id === payload.id)

        user.status = payload.status
    },
    deleteUser (state, payload) {
        state.data = state.data.filter(item => item.id !== payload.id)
    }
}

const actions = {}

const getters = {
    getUsers: state => state.data
}

export default {
    state,
    mutations,
    actions,
    getters
}
